import { useComponent, useElement, useLocale } from "../../../hooks";
import { usePackageWorkListAdmin } from "./hooks";

export const PackageWorkListAdmin = () => {
  const { t } = useLocale();
  const Input = useElement("Input");
  const Table = useComponent("Table");
  const { trackScrolling, searchKey, search, tableContent, activeShownTotal } =
    usePackageWorkListAdmin();

  return (
    <div id="content-box" className="content" onScroll={trackScrolling}>
      <h1 className="title flex">Daily Package Work</h1>
      <div className="filter-box">
        <div className="search-box">
          <Input
            name="searchKey"
            value={searchKey || ""}
            placeholder={t("placeholder.search")}
            onChange={search}
          />
        </div>
      </div>
      <Table data={tableContent} pageSize={activeShownTotal} />
    </div>
  );
};
